import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { IntlProvider, defineMessages } from 'react-intl'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Redirect } from 'react-router-dom'
import { compose } from 'recompose'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import {
  faEnvelope,
  faEdit,
  faTrash,
  faBell,
  faSearch,
  faTimesCircle,
  faArrowLeft,
  faPercent,
  faGraduationCap,
  faAlignLeft,
  faTable,
  faPrint,
} from '@fortawesome/free-solid-svg-icons'
import meta from './meta'
import { start, setChangedRoute, setFirstUrl,
  setCountryCode, logError } from '../../common/app/actions'
import { loadNotifications } from '../../common/notifications/actions'
import routes from './routes'
import { SwitchWithRoutes, FlashMessage, Header, Guide, Button, Footer } from '../components'
import { getCookie, ieWarningSeen } from '../../common/lib/cookies'

import './styles/App.scss'

library.add(fab, faPercent, faEnvelope, faEdit, faTrash, faBell, faSearch,
  faTimesCircle, faArrowLeft, faGraduationCap, faAlignLeft, faTable, faPrint)

class App extends React.Component {
  constructor(props) {
    super(props)

    /* move to header notifications panel */
    this.state = {
      intervalId: null,
      notificationsIntervalSet: false,
    }
  }

  componentDidMount() {
    const { start, location, setFirstUrl, setCountryCode } = this.props
    start()

    setFirstUrl(location.pathname)
    setCountryCode()
  }

  componentDidCatch(error) {
    const { logError, location } = this.props

    logError({
      name: error.name,
      message: error.message,
      stack: error.stack,
      path: location.pathname
    })
  }

  componentWillReceiveProps(nextProps) {
    const { location, setChangedRoute, routeChanged } = this.props
    const routeDiff = nextProps.location !== location
    if (routeDiff && !routeChanged) {
      setChangedRoute()

      const fixedUnderlay = document.getElementById('search-bar-underlay')
      if (fixedUnderlay) {
        fixedUnderlay.addEventListener('touchmove', function (e) {
          e.preventDefault()
        }, false)
      }
    }
  }

  render() {
    const {
      errors,
      location,
      viewer,
      loader,
      intlState,
      countryCode,
    } = this.props

    const { defaultLocale, initialNow, messages } = intlState

    let showIEWarning = null
    if (typeof window !== 'undefined') {
      showIEWarning = document && (/* @cc_on!@*/false || !!document.documentMode)
      const seenWarning = getCookie('ieWarningSeen')
      if (seenWarning) {
        showIEWarning = false
      }
    }

    let { currentLocale } = intlState
    if (viewer && viewer.userLanguage) currentLocale = viewer.userLanguage
    else currentLocale = countryCode 

    if (!['en', 'cs', 'sk'].includes(currentLocale)) currentLocale = 'en'

    const notFound = errors.filter(e => e.code === 404).size > 0
    const unauthorized = errors.filter(e => e.code === 401).size > 0

    if (unauthorized) window.location.href = '/auth/sign-out'

    return (
      notFound && location.pathname !== '/404' ?
        <Redirect to="/404" />
      :
        <IntlProvider
          defaultLocale={'en'}
          initialNow={initialNow}
          key={currentLocale}
          locale={currentLocale}
          messages={messages[currentLocale]}
        >
          <div className="app-container">
            <Helmet
              htmlAttributes={{ lang: 'en' }}
              titleTemplate={meta.title}
              meta={meta.metas}
              link={meta.links}
            />
            <Header viewer={viewer} />
            <FlashMessage />
            {/* <Guide /> */}
            { loader && <div className="app-loader" /> }
            {
              showIEWarning &&
              <div className="ie-warning">
                <p>
                  Aplikácia, nemusí pracovať úplne správne v prehliadači Internet Explorer.
                  Odporúčame používať iný prehliadač.
                </p>
                <Button positive onClick={() => ieWarningSeen()}>
                  Ok
                </Button>
              </div>
            }
            <SwitchWithRoutes routes={routes} notFound />
            {/*
            <Footer />
            */}
          </div>
        </IntlProvider>
    )
  }
}

App.defaultProps = {
  viewer: null,
  loader: false,
  routeChanged: false,
  subjects: [],
}

App.propTypes = {
  errors: PropTypes.object.isRequired,
  start: PropTypes.func.isRequired,
  loadNotifications: PropTypes.func.isRequired,
  setCountryCode: PropTypes.func.isRequired,
  setChangedRoute: PropTypes.func.isRequired,
  setFirstUrl: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  intlState: PropTypes.object.isRequired,
  logError: PropTypes.func.isRequired,
  viewer: PropTypes.object,
  loader: PropTypes.bool,
  routeChanged: PropTypes.bool,
}

const enhance = compose(
  withRouter,
  connect(state => ({
    viewer: state.users.viewer,
    errors: state.app.errors,
    routeChanged: state.app.routeChanged,
    intlState: state.intl,
    loader: state.loader.loader,
    countryCode: state.app.countryCode,
  }), { start, loadNotifications, logError, setChangedRoute,
    setFirstUrl, setCountryCode }),
)

export default enhance(App)



// WEBPACK FOOTER //
// ./src/browser/app/App.js